import * as tslib_1 from "tslib";
import { injectGlobal } from 'styled-components';
// tslint:disable-next-line:no-unused-expression
injectGlobal(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  h1, h2, h3, h4, h5, h6, p {\n    margin: 0;\n  }\n"], ["\n  h1, h2, h3, h4, h5, h6, p {\n    margin: 0;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=resetTextStyle.js.map